var map = {
	"./absen/absen.module": [
		"./src/app/layout/absen/absen.module.ts",
		"absen-absen-module"
	],
	"./layout/layout.module": [
		"./src/app/layout/layout.module.ts",
		"layout-layout-module"
	],
	"./peta/peta.module": [
		"./src/app/layout/peta/peta.module.ts",
		"peta-peta-module"
	],
	"./verifikasi/verifikasi.module": [
		"./src/app/layout/verifikasi/verifikasi.module.ts",
		"verifikasi-verifikasi-module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error('Cannot find module "' + req + '".');
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return __webpack_require__.e(ids[1]).then(function() {
		var module = __webpack_require__(ids[0]);
		return module;
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;